module.exports = __webpack_public_path__ + "4a34bd8865e4ff1188735e94022e5b09.jpg";